import { Logger } from '@/scopes/common/domain/types'
import { NewRelicLoggerOptions } from '@/scopes/common/infrastructure/logging/types'

export function createNewRelicLogger({ scope, windowObj = globalThis }: NewRelicLoggerOptions): Logger {
  function logError(error: Error, info?: { [key: string]: unknown }) {
    if (!windowObj.newrelic?.noticeError)
      return

    windowObj.newrelic.noticeError(error, { scope, ...info })
  }

  function logEvent(name: string, info?: { [key: string]: unknown }) {
    if (!windowObj.newrelic?.addPageAction)
      return

    windowObj.newrelic.addPageAction(name, { ...info, scope })
  }

  function setContext(key: string, value: unknown) {
    if (!windowObj.newrelic?.setCustomAttribute)
      return

    windowObj.newrelic.setCustomAttribute(key, value)
  }

  return {
    logError,
    logEvent,
    setContext,
  }
}
